import { jsx as _jsx } from "react/jsx-runtime";
import { GripVertical } from 'lucide-react';
export const DragHandle = ({ dragHandleProps, className = '', ariaLabel = 'Drag to reorder', }) => {
    const { attributes, listeners, setActivatorNodeRef, isDragging, disabled } = dragHandleProps;
    return (_jsx("button", { ref: setActivatorNodeRef, type: "button", className: `
        flex items-center justify-center
        min-w-[44px] min-h-[44px]
        cursor-grab
        text-default-400
        hover:text-default-600
        focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        disabled:cursor-not-allowed disabled:opacity-50
        ${isDragging ? 'cursor-grabbing' : ''}
        ${className}
      `.trim(), "aria-label": ariaLabel, disabled: disabled, ...attributes, ...listeners, children: _jsx(GripVertical, { className: "w-5 h-5" }) }));
};
export default DragHandle;
//# sourceMappingURL=DragHandle.js.map